import {useState} from "react";

import {ComboboxGeneric} from "@/components/ui/combobox-generic";
import {getStorageItem} from "@/src/modules/core/lib";

import {DailyActivityReportCode} from "../types";

type DarCodeComboboxProps = {
  value: DailyActivityReportCode | null;
  onChange: (value: DailyActivityReportCode | null) => void;
};

export function DarCodeCombobox({value, onChange}: DarCodeComboboxProps) {
  const [dailyActivityReportCodes] = useState<DailyActivityReportCode[]>(
    getStorageItem("dailyActivityReportCodes"),
  );

  return (
    <ComboboxGeneric<DailyActivityReportCode>
      items={dailyActivityReportCodes}
      value={value}
      onChange={onChange}
      getItemKey={(item) => `dar-code-${item.daily_activity_report_code_id}`}
      getItemLabel={(item) => item.type}
      isItemEqual={(item, selected) =>
        item.daily_activity_report_code_id === selected?.daily_activity_report_code_id
      }
      placeholder="Select code"
      emptyMessage="No items found."
    />
  );
}
